<template>
  <div class="page-wrap page-wrap--wide home">
    <h1 class="page-title">Call Agent Helper</h1>
    <p class="page-subtitle">
      A helper tool designed to make managing website users easier. Pick a tool
      to get started, or read the examples below to work out which one you need.
    </p>

    <!-- Tools as a grid of links. Previously the landing page was an
         always-expanded FAQ with no way to click through to anything. -->
    <v-row>
      <v-col v-for="tool in tools" :key="tool.to" cols="12" sm="6">
        <v-card :to="tool.to" class="tool-card tool-tile h-100" elevation="2">
          <div class="tool-card__accent"></div>
          <v-card-item class="pt-4">
            <template v-slot:prepend>
              <v-avatar color="secondary" rounded="lg" size="40">
                <v-icon :icon="tool.icon" color="#231F20"></v-icon>
              </v-avatar>
            </template>
            <v-card-title class="text-subtitle-1 font-weight-bold">{{ tool.title }}</v-card-title>
          </v-card-item>
          <v-card-text class="tool-tile__summary">{{ tool.summary }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <h2 class="section-title">When to use each tool</h2>

    <!-- Same copy as before, but driven off the `tools` array instead of five
         hand-written panels that used <v-row> purely to force line breaks. -->
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel v-for="tool in tools" :key="tool.to" :title="tool.title">
        <v-expansion-panel-text>
          <p>{{ tool.summary }}</p>
          <p class="example-label">Example</p>
          <p>{{ tool.example }}</p>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: "HomeComponent",
  data: () => ({
    panel: [],
    tools: [
      {
        title: "Change Login Email",
        to: "/change-email",
        icon: "mdi-email-edit-outline",
        summary:
          "Change the email address associated with a user's website login.",
        example:
          "John Brown calls the customer support number stating that he wants to change his email from john.brown@gmail.com to john.brown@aol.com. Use this component to achieve this.",
      },
      {
        title: "Change Membership #",
        to: "/change-membership",
        icon: "mdi-card-account-details-outline",
        summary:
          "Change the membership number associated with a website login.",
        example:
          "Beyoncé calls the customer support number stating that she tried to associate her online account to her membership, but she typed in her membership number wrong. She meant to type in 412344 but she actually typed 412345. This means that the website is now pulling up the wrong membership when she signs in. To fix this, use the change membership # component.",
      },
      {
        title: "Update Virtual Membership Card",
        to: "/update-card",
        icon: "mdi-wallet-membership",
        summary: "Update a Google or Apple Virtual Membership Card.",
        example:
          "Darth Vader calls customer service, explaining that he renewed his membership in 2023 and received a new virtual card. However, the card still displays the 2023 expiration date instead of 2024, indicating a discrepancy. Use the Update Virtual Membership Card component to fix this.",
      },
      {
        title: "Resend Login Code",
        to: "/resend-code",
        icon: "mdi-lock-reset",
        summary:
          "Send the member a new login verification code to the destination you choose.",
        example:
          "Leonardo the ninja turtle calls member services, explaining he never received his one-time passcode to log in. He'd like it resent to either his email or phone. Use the Resend Login Code Component to fix this.",
      },
    ],
  }),
};
</script>

<style scoped>
.home {
  text-align: left;
}

/* The shared rule centres the subtitle block; this page is left-aligned. */
.page-subtitle {
  margin-left: 0;
}

.tool-tile {
  overflow: hidden;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.tool-tile:hover {
  transform: translateY(-2px);
}

.tool-tile__summary {
  padding-top: 0;
  opacity: 0.85;
  line-height: 1.5;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  margin: 2.5rem 0 1rem;
}

.example-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.65;
  margin: 1rem 0 0.25rem;
}
</style>
